export function Pricing({ label }: { label: string }) {
  return (
    <div className="flex-x gap-1 text-secondary w-100 px-3 py-2 justify-content-between">
      <span className="flex-grow-1">{label}</span>
      <span className="spinner spinner-sm" />
    </div>
  );
}
